import {useTranslation} from "react-i18next"
import AddProjectBtn from "../../components/add-project-btn/AddProjectBtn"
import openRedFolderIcon from "../../assets/icon/open-red-folder.svg"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"

export default function EcpProjectsHeader() {
    const {t} = useTranslation()
    const {ecpProjectsContext} = useEcpProjectsContext()
    let title = ecpProjectsContext.tab.replace("-", " ")
    title = title[0].toUpperCase() + title.slice(1)
    if (title === "My projects") {title = "My ECP projects"}
    return (
        <>
        <div className="SECTION ECP-PROJECTS-HEADER">
            <AddProjectBtn type={"ecp"}/>
            <h2><img src={openRedFolderIcon} alt=""/>{t(`${title}`)}</h2>
            {title === "My ECP projects" ?
                <><p>{t("Pick up where you left off.")}</p></> :
                title === "Shared projects" ?
                <><p>{t("Contribute to your team's projects.")}</p></> :
                <><p>{t("Restore your deleted projects.")}</p></>
            }
        </div>
        </>
    )
}